module.exports = __webpack_public_path__ + "static/img/1.a7b0e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nanjing/1.jpg
// module id = PwG2
// module chunks = 19